import { useTranslation } from "react-i18next";
import { Accordion, Box } from "@chakra-ui/react";
import React from "react";
import { QuestionAccordionItem } from "../../QuestionsAndAnswers";

function ReusableCategory({ currentElement: data, tabKey }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierQuestionnaire.scopeThree"
  });

  const mapBooleanAnswer = (answerString) => {
    return answerString === "true" ? t(`buttons.yes`) :
      answerString === "false" ? t(`buttons.no`) : answerString;
  };

  const mapQuestionAnswers = (attrKey) => {
    if (attrKey.toLowerCase().includes("included")) {
      return data[attrKey].map(obj => {
        return {
          ...obj,
          answer: mapBooleanAnswer(obj["answer"])
        };
      });
    } else {
      return data[attrKey];
    }
  };

  const mapQuestion = (attrKey) => {
    if (attrKey.toLowerCase().includes("included")) {
      return t("includeQuestion", { activity: t(`categories.${tabKey}.activity`) });
    } else {
      switch (attrKey) {
        case "reasonExclusion":
          return t("reasonForExclusion");
        case "carbonEmission":
          return t("emissionsQuestion");
        case "materialityThreshold":
          return t("materialityThresholdQuestion", { activity: t(`categories.${tabKey}.activity`) });
        case "dataCollectionMethods":
          return t("collectDataMethods");
        case "calculationMethods":
        case "howVerifyData":
          return t(attrKey);
        default:
          return "";
      }
    }
  };

  return (
    <Box
      marginTop={5}
      flexGrow="1"
      overflowY="auto"
      overflowX="visible"
      paddingBlockEnd="4"
      paddingInline="2"
      paddingBottom="2"
      marginInline="-2"
      height="calc(100% - var(--chakra-space-14))"
    >
      {data && <Accordion defaultIndex={[0]} allowToggle={true}>
        {Object.keys(data).map(attrKey => {
          const answersArr = mapQuestionAnswers(attrKey);
          const question = mapQuestion(attrKey);
          return <QuestionAccordionItem
            key={`${attrKey}-category-one-question`}
            question={question}
            answers={answersArr}
          />;
        })}
      </Accordion>}
    </Box>
  );
}

export default ReusableCategory;